import { GapFinderPage } from '@/features/events/routes/GapFinderPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/events/tools/gap-finder')({
  component: GapFinderPage,
});
